
import { PromotionReward } from '@betty/promos';

import { Text } from '@betty/moonlight';

import styles from './SingleReward.module.css';
import { getLandingRewardAmount } from '../../../../utils/getLandingRewardAmount';
import { rewardDescriptionMap } from './BundleRewards/BundleRewards.constants';

function SingleReward({ reward }: { reward: PromotionReward }) {
  return (
    <div className={styles.singleRewardWrapper}>
       <div className={styles.mainRewardLabel}>
          <Text variant="giant" gradient="darkSurfaceAccent">
            {getLandingRewardAmount(reward)}
          </Text>
       </div>
      <div className={`${styles.mainLabel} ${styles.last}`}>
        <Text variant="h4" gradient="darkSurfaceAccent">
          {rewardDescriptionMap.get(reward.rewardTarget)}
        </Text>
      </div>
    </div>
  );
}

export default SingleReward;
